import { Task } from '../../models/task';
import { ApiResponse, httpService } from '../httpService';

export interface GetTaskParams {
  skip?: number;
  take?: number;
  filter?: string;
  includeDeleted?: boolean;
}

interface UserDetailsToAddOnTask {
  isActive: boolean;
  employeesId: string;
}

const tasksApiUrl = '/api/Tasks';

export const getTasks = async (
  params: GetTaskParams = {}
): Promise<ApiResponse<Task>> => {
  const response = await httpService.get<ApiResponse<Task>>(tasksApiUrl, {
    params,
  });

  return response.data;
};

export const getProjectTasks = async (
  idProject: string,
  params: GetTaskParams = {}
): Promise<ApiResponse<Task>> => {
  const response = await httpService.get<ApiResponse<Task>>(
    `/api/Projects/${idProject}/Tasks`,
    { params }
  );

  return response.data;
};

export const addNewTask = async (newTask: Partial<Task>): Promise<void> => {
  await httpService.post(tasksApiUrl, newTask);
};

export const deleteTask = async (taskId: string): Promise<void> => {
  await httpService.delete(`${tasksApiUrl}/${taskId}`);
};

export const editTask = async (
  taskId: string,
  editTaskInfo: Partial<Task>
): Promise<void> => {
  await httpService.put(`${tasksApiUrl}/${taskId}`, editTaskInfo);
};

export const addUsersToTask = async (
  taskId: string,
  userDetails: UserDetailsToAddOnTask[]
): Promise<void> => {
  await httpService.put(
    `${tasksApiUrl}/${taskId}/UpdateEmployeeStatus`,
    userDetails
  );
};

interface DuplicateTaskParams {
  taskId: string;
  projectId: string;
}

export const duplicateTask = async (
  params: DuplicateTaskParams
): Promise<void> => {
  await httpService.post(`${tasksApiUrl}/duplicate`, params);
};
